"use client";

import { NormalText } from "@/components/text/NormalText";

export function StarPoint({ children }: { children: React.ReactNode }) {
  return (
    <li className="flex gap-x-2">
      <span className="text-xl">🎵</span>
      <NormalText elementType="span">{children}</NormalText>
    </li>
  );
}
